import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from './Preloader.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Preloader = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Preloader, _React$PureComponent);
  var _super = _createSuper(Preloader);
  function Preloader() {
    _classCallCheck(this, Preloader);
    return _super.apply(this, arguments);
  }
  _createClass(Preloader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        size = _this$props.size,
        stopColorForOffset0 = _this$props.stopColorForOffset0,
        stopColorForOffset1 = _this$props.stopColorForOffset1;
      var preloaderDefaultStyle = {
        height: size,
        width: size
      };
      var gradientId = "preloader-gradient-".concat(id);
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/forbid-elements
        _jsxs("svg", _objectSpread(_objectSpread({}, mergeStyles(styles['preloader'], preloaderDefaultStyle, this.props.preloaderStyle)), {}, {
          viewBox: "0 0 40 40",
          children: [/*#__PURE__*/_jsx("defs", {
            children: /*#__PURE__*/_jsxs("linearGradient", {
              id: gradientId,
              gradientUnits: "userSpaceOnUse",
              y1: "30",
              x2: "40",
              y2: "30",
              children: [/*#__PURE__*/_jsx("stop", {
                offset: "0",
                stopColor: stopColorForOffset0 || '#0076eb'
              }), /*#__PURE__*/_jsx("stop", {
                offset: "1",
                stopColor: stopColorForOffset1 || '#fff',
                stopOpacity: "0"
              })]
            })
          }), /*#__PURE__*/_jsx("path", {
            fill: "url(#".concat(gradientId, ")"),
            d: "M20,35c-8.3,0-15-6.7-15-15H0c0,11,9,20,20,20c11,0,20-9,20-20h-5C35,28.3,28.3,35,20,35z"
          })]
        }))
      );
    }
  }]);
  return Preloader;
}(React.PureComponent);
_defineProperty(Preloader, "defaultProps", {
  id: styles['preloader'],
  size: 16
});